import React, { FC, useEffect } from 'react';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { VaultButton } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/VaultButton';
import { useLiquidityByIchiState } from '@app/state/liquidityByIchiStore';

interface Props {
  vaultsAddresses: string[] | null | undefined;
}

export const VaultSelector: FC<Props> = ({ vaultsAddresses }) => {
  const {
    actions: { setVaultId }
  } = useLiquidityByIchiState();

  useEffect(() => {
    if (vaultsAddresses?.length) {
      setVaultId(vaultsAddresses[0]);
    }
  }, [setVaultId, vaultsAddresses]);

  return (
    <VStack w="100%" gap={4}>
      <HStack
        bg="gray.2"
        borderRadius={4}
        w="100%"
        justifyContent="space-between"
        p={4}
      >
        <Text fontSize={16}>Select a vault</Text>
        <CheckIcon color="success" width={4} height={4} />
      </HStack>
      <HStack
        width="100%"
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'gray.5',
          padding: '6px',
          maxWidth: '595px',
          flexWrap: 'wrap'
        }}
      >
        {vaultsAddresses?.map((vaultAddress: string) => {
          return <VaultButton vaultAddress={vaultAddress} key={vaultAddress} />;
        })}
      </HStack>
    </VStack>
  );
};
